import { createDynamicThunk } from ".";

export const getVendorListThunk = createDynamicThunk({
  typePrefix: "vendors/getVendorListThunk",
  useHandleSearch: true,
});

export const addVendorThunk = createDynamicThunk({
  typePrefix: "vendors/addVendorThunk",
  endpoint: "/vendors",
  method: "POST",
  refreshList: true,
  listThunk: getVendorListThunk,
});

export const editVendorThunk = createDynamicThunk({
  typePrefix: "vendors/editVendorThunk",
  endpoint: "/vendors",
  method: "PUT",
  refreshList: true,
  listThunk: getVendorListThunk,
  transformResponse: (response) => response,
});

export const deleteVendorThunk = createDynamicThunk({
  typePrefix: "/deleteVendorThunk",
  endpoint: "/softDeleteMul",
  method: "POST",
  refreshList: true,
  listThunk: getVendorListThunk,
});
